import {
  CloseOutlined,
  CloudUploadOutlined,
  FileExcelOutlined,
  InfoCircleOutlined,
} from "@ant-design/icons";
import {
  CommandBar,
  MessageBar,
  MessageBarType,
  Pivot,
  PivotItem,
  PivotLinkSize,
  Link,
  ProgressIndicator,
} from "@fluentui/react";
import {
  Button,
  DatePicker,
  Space,
  Form,
  Tooltip,
  Layout,
  Input,
  Radio,
  notification,
  message,
  Drawer,
  Badge,
} from "antd";
import Dragger from "antd/lib/upload/Dragger";
import React, { createContext, useContext } from "react";
import moment from "moment";
import { Save, X } from "react-feather";
import { SubPageHeaderTitle } from "../../../shared/SubPageHeaderTitle";
import { getPickerDate, toAntPickerDate } from "../../../Utility/modules/datePicker";
import EbendoDailyProductionStore from "../store/ebendodailyproductionstore";
import { observer } from "mobx-react-lite";

import { ENV } from "../../../Infrastructure/EnvironmentConfig";
import { EbendoErrorLogs } from "./EbendoErrorLogs";
import { EbendoManualFormEntry } from "./EbendoManualFormEntry";
import { EbendoDailyProductionForm } from "./EbendoDailyProductionForm";

const { Content, Sider } = Layout;
const _ = require("underscore");
const initData = {
  aseRiverExport: 0,
  aseRiverUptime: 0,
  bsw: 0,
  crudeInjectionGGF: 0,
  ebendoDailyProductionId: 0,
  flareGas: 0,
  forcadosExport: 0,
  forcadosUptime: 0,
  fuelGas: 0,
  gas: 0,
  condensate: 0,
  gasSuppliedToGasPlant: 0,
  netProduction: 0,
  oil: 0,
  productionDate: moment(new Date())._d,
  stationDownHrs: 0,
  water: 0,
  stationAPI: 0,
  remarks: "",
};

const EbendoStoreCtx = createContext(EbendoDailyProductionStore);
export const EbendoDailyProductionUpload = observer(() => {
  const ebendoDailyProductionStore = useContext(EbendoStoreCtx);
  const uploadprops = {
    name: "file",
    accept: ".xls,.xlsx",
    multiple: false,
    beforeUpload: (file, fileList) => {
      if (_.isEmpty(ebendoDailyProductionStore.sheetName)) {
        notification.error({
          key: "error",
          message: "SPARS Feedback",
          description:
            "input deck sheet name is required,enter the field production report sheetname",
        });

        return false;
      }
      return true;
    },
    headers: {
      method: "Post",
    },
    data: "newtemplate",
    action: `${ENV.API_ROOT}/EbendoDailyProduction/ImportEbendoDailyProductionExcel?data=${ebendoDailyProductionStore.sheetName}`,

    onChange(info) {
      try {
        const { status } = info.file;

        if (status === "done") {
          const { productionData, errors, wellPara } = info.file.response;
          ebendoDailyProductionStore.wellparameters.clear();

          ebendoDailyProductionStore.initFormaData = productionData;
          if (wellPara) {
            wellPara.forEach((p) => {
              ebendoDailyProductionStore.wellparameters.set(
                p.ebendoDailyProductionWellId,
                p
              );
            });
          }

          if (errors.length) {
            ebendoDailyProductionStore.uploadErrors = errors;

            ebendoDailyProductionStore.selTab = "2";
          } else {
            ebendoDailyProductionStore.initFormaData = productionData;
            ebendoDailyProductionStore.uploadDate = moment(
              productionData.productionDate
            )._d;
            ebendoDailyProductionStore.uploadErrors = [];
            ebendoDailyProductionStore.selTab = "1";
          }
        } else if (status === "error") {
          ebendoDailyProductionStore.showUploadErrorMessage = true;
          message.error(`${info.file.name} file preview failed.`);
          notification.error({
            message: "SPARS Feedback",
            description: `${info.file.response}`,
          });
        }
      } catch (error) {
        message.error(`${info.file.name} file preview failed.`);
      }
    },
  };
  return (
    <Drawer
      title={
        <>
          <CloudUploadOutlined styel={{ color: "red" }} />{" "}
          <span>{`EBENDO FIELD PRODUCTION UPLOAD for ${moment(
            ebendoDailyProductionStore.uploadDate
          ).format("DD-MMM-YYYY")}`}</span>
        </>
      }
      visible={ebendoDailyProductionStore.showEbendoDailyProductionDialog}
      onClose={() => {
        ebendoDailyProductionStore.showEbendoDailyProductionDialog = false;
      }}
      width={"80%"}
      destroyOnClose={true}
      drawerStyle={{ borderTop: "5px solid #F29C1F" }}
    >
      <div className="ms-Grid" dir="ltr" style={{ padding: "10px" }}>
        <div className="ms-Grid-row">
          <div className="ms-Grid-col ms-sm12">
            <div className="ms-Grid" dir="ltr">
              <div className="ms-Grid-row">
                <div className="ms-Grid-col ms-sm4">
                  <Radio.Group
                    buttonStyle="solid"
                    value={ebendoDailyProductionStore.view}
                    onChange={({ target }) => {
                      ebendoDailyProductionStore.view = target.value;
                    }}
                  >
                    <Radio.Button value="upload">
                      Input Deck Upload
                    </Radio.Button>
                    <Radio.Button value="manual">
                      Production Data Entry
                    </Radio.Button>
                  </Radio.Group>
                </div>

                <div className="ms-Grid-col ms-sm4">
                  {ebendoDailyProductionStore.view === "upload" && (
                    <>
                      <div style={{ textAlign: "center" }}>
                        {" "}
                        <span style={{ color: "red" }}>
                          Don't have EBENDO Daily Field Production Input Deck?
                        </span>
                      </div>
                      <div style={{ textAlign: "center" }}>
                        <Tooltip title="click to download  EBENDO Daily Field Production  template for Ebendo Asset operations.">
                          <Link
                            underline={true}
                            style={{ textDecoration: "underline" }}
                            onClick={async () => {
                              try {
                                await ebendoDailyProductionStore.DownlaodDailyProductionTemplate();
                              } catch (error) {
                                notification.error({
                                  message: "SPARS Feedback",
                                  description: error.message,
                                });
                              }
                            }}
                          >
                            Download standard EBENDO Daily Field Production
                            template
                          </Link>
                        </Tooltip>
                      </div>
                    </>
                  )}
                </div>

                <div
                  className="ms-Grid-col ms-sm4"
                  style={{ textAlign: "right" }}
                >
                  <Space>
                    <Button
                      type="primary"
                      disabled={
                        !ebendoDailyProductionStore.isValidProductionData
                      }
                      icon={<Save className="bicon" />}
                      onClick={async () => {
                        try {
                          const retVal =
                            await ebendoDailyProductionStore.saveDailyProduction(
                              ebendoDailyProductionStore.initFormaData
                            );
                          if (retVal.success) {
                            ebendoDailyProductionStore.showEbendoDailyProductionDialog = false;
                            let prod = retVal.production;
                            message.success(
                              `Ebendo Field Production Data upload for ${moment(
                                ebendoDailyProductionStore.uploadDate
                              ).format("dddd DD-MMM-YYYY")} was sucessfull`
                            );
                            ebendoDailyProductionStore.dailyProductions.set(
                              prod.ebendoDailyProductionId,
                              {
                                ...prod,
                                modifiedProductionDate: moment(
                                  prod.productionDate
                                ).format("ddd DD-MMM-YYYY"),
                                strippedRemarks: prod.remarks
                                  ? prod.remarks.replace(/(<([^>]+)>)/gi, " ")
                                  : null,
                              }
                            );
                          } else {
                            notification.error({
                              message: "SPARS Feedback",
                              description: retVal.message,
                            });
                          }
                        } catch (error) {
                          notification.error({
                            message: "SPARS Feedback",
                            description: error.message,
                          });
                        }
                      }}
                    >
                      Save
                    </Button>
                  </Space>
                </div>
              </div>
            </div>
          </div>
        </div>
        {ebendoDailyProductionStore.isDownloadingTemplate && (
          <div className="ms-Grid-row">
            <div className="ms-Grid-col ms-sm12">
              <ProgressIndicator
                description="downloading template,please wait..."
                styles={{ root: { textAlign: "center" } }}
              ></ProgressIndicator>
            </div>
          </div>
        )}
        {ebendoDailyProductionStore.isSaving && (
          <div className="ms-Grid-row">
            <div className="ms-Grid-col ms-sm12">
              <ProgressIndicator
                description="saving production data,please wait..."
                styles={{ root: { textAlign: "center" } }}
              ></ProgressIndicator>
            </div>
          </div>
        )}

        {ebendoDailyProductionStore.showUploadErrorMessage && (
          <MessageBar
            type={MessageBarType.blocked}
            styles={{ root: { backgroundColor: "rgb(253, 231, 233)" } }}
            truncated={true}
            isMultiline={false}
          >
            This error may occur due to alteration of the standard upload
            template like inserting rows and columns in the upload workbook,
            thereby distorting the cell adresses, this can be resolved by
            mapping the cell adresses correctly.
            <Link href="/main/administration/settings">Go to Mapping.</Link>
          </MessageBar>
        )}
      </div>

      {ebendoDailyProductionStore.view === "upload" ? (
        <Layout style={{ background: "#fff" }}>
          <Content style={{ background: "#fff" }}>
            <Layout>
              <Sider
                width={300}
                style={{
                  background: "#F0F2F5",
                  height: "100vh",
                  padding: "10px",
                }}
              >
                <div className="ms-Grid" dir="ltr">
                  <div
                    className="ms-Grid-row"
                    style={{ background: "#F0F2F5" }}
                  >
                    <div className="ms-Grid-col ms-sm12">
                      {" "}
                      <SubPageHeaderTitle title="Browse Pane" />
                    </div>
                  </div>
                  <div className="ms-Grid-row">
                    <div className="ms-Grid-col ms-sm12">
                      <Form layout="vertical">
                        <Form.Item
                          label={
                            <span style={{ color: "red" }}>
                              Production Date*
                            </span>
                          }
                        >
                          <Tooltip title="Ebendo field production date">
                            <DatePicker
                              value={toAntPickerDate(ebendoDailyProductionStore?.uploadDate)}
                              onChange={(date, dateString) => {
                                if (date) {
                                  ebendoDailyProductionStore.uploadDate =
                                    getPickerDate(date);
                                  let dateVal = date.format(
                                    "YYYY-MM-DDT00:00:00.000Z"
                                  );

                                  ebendoDailyProductionStore.initFormaData.productionDate =
                                    dateVal;
                                }
                              }}
                              style={{ width: "100%" }}
                              defaultValue={toAntPickerDate(new Date())}
                              format={"DD-MMM-YYYY"}
                              locale={"en_US"}
                            />
                          </Tooltip>
                        </Form.Item>

                        <Form.Item
                          label={
                            <span style={{ color: "red" }}>
                              Input Deck WorkSheet *
                            </span>
                          }
                        >
                          <Tooltip title="enter the sheetname where the ebendo field production is located in the browsed workbook e.g Daily Report ">
                            <Input
                              placeholder="Worksheet Name"
                              value={ebendoDailyProductionStore.sheetName}
                              defaultValue="Daily Report"
                              onChange={({ target }) => {
                                ebendoDailyProductionStore.sheetName =
                                  target.value;
                              }}
                            />
                          </Tooltip>
                        </Form.Item>
                        <Form.Item>
                          <Dragger
                            style={{
                              width: "100%",
                              backgroundColor: "transparent",
                            }}
                            multiple={false}
                            {...uploadprops}
                          >
                            <p className="ant-upload-drag-icon">
                              <FileExcelOutlined style={{ color: "#68D391" }} />
                            </p>
                            <p className="ant-upload-text">
                              Browse for Ebendo Field Production Input Deck
                            </p>
                          </Dragger>
                        </Form.Item>
                      </Form>
                    </div>
                  </div>
                </div>
              </Sider>
              <Content style={{ background: "#F0F2F5" }}>
                <div
                  className="ms-Grid"
                  dir="ltr"
                  style={{ background: "white" }}
                >
                  <Pivot
                    linkSize={PivotLinkSize.normal}
                    selectedKey={ebendoDailyProductionStore.selTab}
                    onLinkClick={(item, ev) => {
                      ebendoDailyProductionStore.selTab = item.props.itemKey;
                    }}
                  >
                    <PivotItem
                      headerText="Field Production and Evacuation Data"
                      itemKey="1"
                    >
                      <div
                        className="ms-Grid-row"
                        style={{ background: "white" }}
                      >
                        <CommandBar
                          items={[
                            {
                              key: "clear",
                              text: "Clear Entries",
                              onRenderIcon: () => <X />,
                              onClick: async () => {
                                ebendoDailyProductionStore.initFormaData =
                                  initData;
                                ebendoDailyProductionStore.uploadDate = moment(
                                  new Date()
                                );
                                await ebendoDailyProductionStore.loadInitialWellParameters();
                                ebendoDailyProductionStore.showNaocDailyProductionDialog = true;
                              },
                            },
                          ]}
                        />
                      </div>

                      <EbendoDailyProductionForm />
                    </PivotItem>
                    <PivotItem
                      headerText="Deck Upload Data Validation"
                      itemKey="2"
                      onRenderItemLink={(link, defaultRenderer) => (
                        <span>
                          <InfoCircleOutlined style={{ color: "red" }} />{" "}
                          {defaultRenderer(link)}{" "}
                          <Badge
                            count={
                              ebendoDailyProductionStore.uploadErrors.length
                            }
                          />
                        </span>
                      )}
                    >
                      <EbendoErrorLogs />
                    </PivotItem>
                  </Pivot>
                </div>
              </Content>
            </Layout>
          </Content>
        </Layout>
      ) : (
        <EbendoManualFormEntry />
      )}
    </Drawer>
  );
});

